export function calcDiscountedPrice(price: any, discount: any) {
  price = Number(price);
  discount = Number(discount);
  if (discount) {
    return price - calcDiscountAmount(price, discount);
  }

  return price;
}

export function calcDiscountAmount(price: any, discount: any) {
  price = Number(price);
  discount = Number(discount);
  if (discount) {
    return Math.floor(price * discount / 100);
  }

  return 0;
}
